<template>
  <nav
    :class="[
      'fixed w-full flex z-50 transition-all duration-500 px-6 py-4 content-center px-6 py-4 justify-between',
      scrolled ? 'bg-white shadow-lg py-2' : 'bg-transparent',
    ]"
  >
    <div class="flex lg:flex-1 transition-transform duration-300">
      <a href="#" class="-m-1.5 p-1.5">
        <span class="sr-only">Optimuz</span>
        <img
          class="h-3/4 w-auto transition-all duration-300"
          :class="scrolled ? 'scale-90' : 'scale-100'"
          :src="logoOptimuz"
          alt="Optimuz Logo"
        />
      </a>
    </div>
    <div class="flex lg:hidden justify-between">
      <button
        type="button"
        class="-m-2.5 inline-flex rounded-md p-2.5 text-gray-700"
        @click="mobileMenuOpen = true"
      >
        <span class="sr-only">Abrir menu</span>
        <Bars3Icon class="size-6" aria-hidden="true" />
      </button>
    </div>
    <div class="w-64 flex-1 hidden lg:flex lg:gap-x-12 content-center flex-wrap">
      <a
        v-for="item in navigation"
        :key="item.name"
        :href="item.href"
        class="text-sm/6 font-semibold transition-all duration-300"
        :class="scrolled ? 'text-gray-900' : 'text-black'"
      >
        {{ item.name }}
      </a>
    </div>
    <!-- <div class="hidden lg:flex lg:flex-1 lg:justify-end">
       <a href="#" class="text-sm/6 font-semibold text-gray-900">Login <span aria-hidden="true">&rarr;</span></a>
    </div> -->
  </nav>
  <Dialog as="div" class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
    <DialogPanel
      class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
    >
      <div class="flex items-center justify-between">
        <a href="#" class="-m-1.5 p-1.5">
          <span class="sr-only">Optimuz Movil</span>
          <img class="h-8 w-auto" :src="logoOptimuz" alt="Optimuz Logo" />
        </a>
        <button
          type="button"
          class="-m-2.5 rounded-md p-2.5 text-gray-700"
          @click="mobileMenuOpen = false"
        >
          <span class="sr-only">Close menu</span>
          <XMarkIcon class="size-6" aria-hidden="true" />
        </button>
      </div>
      <div class="mt-6 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10">
          <div class="space-y-2 py-6">
            <a
              v-for="item in navigation"
              :key="item.name"
              :href="item.href"
              class="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
              @click="mobileMenuOpen = false"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="py-6">
            <!-- <a
              href="#"
              class="-mx-3 block rounded-lg px-3 py-2.5 text-base/7 font-semibold text-gray-900 hover:bg-gray-50"
              >Log in</a
            > -->
          </div>
        </div>
      </div>
    </DialogPanel>
  </Dialog>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { Dialog, DialogPanel } from "@headlessui/vue";
import { Bars3Icon, XMarkIcon } from "@heroicons/vue/24/outline";
import logoOptimuz from "@/assets/images/logo-optimuz.png";

const navigation = [
  { name: "Inicio", href: "#inicio" },
  { name: "Productos y Servicios", href: "#productos" },
  { name: "Productos Medicos", href: "/productos-medicos" },
  { name: "Nosotros", href: "#nosotros" },
  { name: "Contáctanos", href: "#contacto" },
];

const mobileMenuOpen = ref(false);
const scrolled = ref(false);

const handleScroll = () => {
  scrolled.value = window.scrollY > 50;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>
